import React from 'react';
import PropTypes from 'prop-types';

const AdvancedFilters = ({ 
  filters, 
  showAdvancedFilters, 
  onFilterChange, 
  onClear, 
  onApply,
  onToggle,
  getFilterCount 
}) => {
  const toggleCategory = (category) => {
    const newCategories = filters.categories.includes(category)
      ? filters.categories.filter(c => c !== category)
      : [...filters.categories, category];
    onFilterChange("categories", newCategories);
  };

  if (!showAdvancedFilters) return null;

  return (
    <div className="advanced-filters">
      <div className="filter-row">
        <div className="filter-group">
          <label htmlFor="price-min">Price Range</label>
          <div className="price-range">
            <input
              id="price-min"
              type="number"
              placeholder="Min $"
              value={filters.priceRange.min}
              onChange={(e) =>
                onFilterChange("priceRange", {
                  ...filters.priceRange,
                  min: e.target.value,
                })
              }
            />
            <span>to</span>
            <input
              id="price-max"
              type="number"
              placeholder="Max $"
              value={filters.priceRange.max}
              onChange={(e) =>
                onFilterChange("priceRange", {
                  ...filters.priceRange,
                  max: e.target.value,
                })
              }
            />
          </div>
        </div>

        <div className="filter-group">
          <span className="filter-label">Categories</span>
          <div className="filter-chips">
            {["Wine", "Beer", "Spirits", "Cocktails", "Non-Alcoholic"].map(
              (category) => (
                <button
                  key={category}
                  className={`filter-chip ${
                    filters.categories.includes(category) ? "selected" : ""
                  }`}
                  onClick={() => toggleCategory(category)}
                >
                  {category}
                </button>
              )
            )}
          </div>
        </div>
      </div>

      <div className="filter-actions">
        <button className="clear-filters" onClick={onClear}>
          Clear All
        </button>
        <button className="apply-filters" onClick={onApply}>
          Apply Filters
        </button>
      </div>
    </div>
  );
};

AdvancedFilters.propTypes = {
  filters: PropTypes.object.isRequired,
  showAdvancedFilters: PropTypes.bool.isRequired,
  onFilterChange: PropTypes.func.isRequired,
  onClear: PropTypes.func.isRequired,
  onApply: PropTypes.func.isRequired,
  onToggle: PropTypes.func.isRequired,
  getFilterCount: PropTypes.func.isRequired,
};

export default AdvancedFilters;
